var render = function render(){var _vm=this,_c=_vm._self._c;return _c('start-page-template',{attrs:{"compact":""}},[_c('recovery-code-form',{attrs:{"authentication-error":_vm.formError,"loading":_vm.isLoading},on:{"submit-code":_vm.onAuthenticate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }